import { render, staticRenderFns } from "./ContestSummaryView.vue?vue&type=template&id=4be3f7ee&scoped=true&"
import script from "./ContestSummaryView.vue?vue&type=script&lang=js&"
export * from "./ContestSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be3f7ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
installComponents(component, {VCardText,VCardTitle})
